import { useEffect, useState } from "react";
import { RequestState } from "../constants/request-state";
import { DateTimeStamp } from "../types/primitives/DateTimeStamp";
import { daysService } from "../services/days.service";
import { isRequestNone } from "../utils/request-state.utils";

export function useHolidays() {
    const [requestState, setRequestState] = useState(RequestState.none);
    const [holidays, setHolidays] = useState<DateTimeStamp[]>([]);

    useEffect(() => {
        if (!isRequestNone) return;

        const doRequest = async () => {
            setRequestState(RequestState.request);
            try {
                const year = new Date().getFullYear();
                const holidays = await daysService.getHolidays(year)
                setHolidays(holidays)
                setRequestState(RequestState.success);
            } catch (e) {
                setRequestState(RequestState.failure);
            }
        }
        doRequest();
    }, [])

    return { requestState, holidays };
}